import { BalanceApi, BalanceWithPrice } from '../../infrastructure/api';

export class LoadBalanceUseCase {
    async execute(
        vehiclePlate: string,
        productId: number,
        token: string
    ): Promise<BalanceWithPrice | null> {
        return await BalanceApi.fetchByVehicleAndProduct(vehiclePlate, productId, token);
    }
}

